import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function getOptimizedImageUrl(url, width = 800) {
  if (!url || typeof url !== "string") return url;

  // Optimize Cloudinary URLs by inserting transformation parameters
  if (url.includes("res.cloudinary.com")) {
    return url.replace("/upload/", `/upload/f_auto,q_auto,w_${width}/`);
  }

  return url;
}
